module.exports = __webpack_public_path__ + "static/media/logo-festicket.0f4f9407.png";